import VendorService from '@/api/VendorService'
import CustomerService from '@/api/CustomerService'
import PartnerService from '@/api/PartnerService'

// initial state
const state = {
  vendor: null,
  vendors: [],
  customer: null,
  customers: [],
  partners: [],
}

function getPartnerContactIdByPlatform (platform, contacts) {
  for (let i in contacts) {
    if (contacts[i].platform == platform) {
      return contacts[i].contact_id
    }
  }
  return null
}

function getPartnerContact (contacts) {
  var email = null,
    tel = null,
    line
  contacts.map(obj => {
    switch (obj.platform) {
      case 'email':
        email = obj.source
        break
      case 'tel':
        tel = obj.source
        break
      case 'line':
        line = obj.source
        break
    }
  })
  return {
    'email': email,
    'tel': tel,
    'line': line,
  }
}

// getters
const getters = {
  getVendor: state => state.vendor,
  getVendors: state => state.vendors,
  getCustomer: state => state.customer,
  getCustomers: state => state.customers,
  getCustomerById: (state) => (customer_id) => {
    return state.customers.find(customer => customer.customer_id === customer_id)
  },
  getVendorById: (state) => (vendor_id) => {
    return state.vendors.find(vendor => vendor.vendor_id === vendor_id)
  },
  getPartners: state => state.partners,
  getPartnerContact: (state) => getPartnerContact,
  getPartnerContactIdByPlatform: (state) => (platform, contacts) => {
    for (let i in contacts) {
      if (contacts[i].platform == platform) {
        return contacts[i].contact_id
      }
    }
    return null
  },
  getDataSetPartnerUpdate: (state) => (partnerType, pickedPartnerId, formPartner, partners) => {
    if (pickedPartnerId == null || pickedPartnerId == '') {
      return null
    }

    var partner,
      partnerContact

    var dataSet = {
      'address': undefined,
      'tax_id': undefined,
      'contacts': {
        'insert': [],
        'update': [],
        'delete': [],
      },
    }

    if (partnerType == 'customer') {
      partner = partners.find(partner => partner.customer_id === pickedPartnerId)
      dataSet['customer_id'] = pickedPartnerId
    } else if (partnerType == 'vendor') {
      partner = partners.find(partner => partner.vendor_id === pickedPartnerId)
      dataSet['vendor_id'] = pickedPartnerId
    }

    partnerContact = partner != null ? getPartnerContact(partner.contacts) : null

    formPartner.address = formPartner.address == null ? '' : formPartner.address
    formPartner.tax_id = formPartner.tax_id == null ? '' : formPartner.tax_id
    formPartner.email = formPartner.email == null ? '' : formPartner.email
    formPartner.tel = formPartner.tel == null ? '' : formPartner.tel

    if (partner !== undefined) {
      if (partner.address !== formPartner.address) {
        dataSet['address'] = formPartner.address.trim().length == 0 ? null : formPartner.address.trim()
      }

      if (partner.tax_id !== formPartner.tax_id) {
        dataSet['tax_id'] = formPartner.tax_id.trim().length == 0 ? null : formPartner.tax_id.trim()
      }

      if (partnerContact.email == null) {
        if (partnerContact.email !== formPartner.email) {
          if (formPartner.email.trim().length > 0) {
            dataSet['contacts'].insert.push({ 'platform': 'email', 'source': formPartner.email })
          }
        }
      } else {
        if (partnerContact.email !== formPartner.email) {
          if (formPartner.email.trim().length > 0) {
            dataSet['contacts'].update.push({ contact_id: getPartnerContactIdByPlatform('email', partner.contacts), 'platform': 'email', 'source': formPartner.email })
          } else {
            dataSet['contacts'].delete.push({ contact_id: getPartnerContactIdByPlatform('email', partner.contacts) })
          }
        }
      }

      if (partnerContact.tel == null) {
        if (partnerContact.tel !== formPartner.tel) {
          if (formPartner.tel.trim().length > 0) {
            dataSet['contacts'].insert.push({ 'platform': 'tel', 'source': formPartner.tel })
          }
        }
      } else {
        if (partnerContact.tel !== formPartner.tel) {
          if (formPartner.tel.trim().length > 0) {
            dataSet['contacts'].update.push({ contact_id: getPartnerContactIdByPlatform('tel', partner.contacts), 'platform': 'tel', 'source': formPartner.tel })
          } else {
            dataSet['contacts'].delete.push({ contact_id: getPartnerContactIdByPlatform('tel', partner.contacts) })
          }
        }
      }

      dataSet.address = (dataSet.address == null && partner.address == null) ? undefined : dataSet.address
      dataSet.tax_id = (dataSet.tax_id == null && partner.tax_id == null) ? undefined : dataSet.tax_id
    } else if (partner == undefined) {
      if (formPartner.address.trim().length > 0) {
        dataSet['address'] = formPartner.address.trim().length == 0 ? null : formPartner.address.trim()
      }
      if (formPartner.tax_id.trim().length > 0) {
        dataSet['tax_id'] = formPartner.tax_id.trim().length == 0 ? null : formPartner.tax_id.trim()
      }
      if (formPartner.email.trim().length > 0) {
        dataSet['contacts'].insert.push({ 'platform': 'email', 'source': formPartner.email })
      }
      if (formPartner.tel.trim().length > 0) {
        dataSet['contacts'].insert.push({ 'platform': 'tel', 'source': formPartner.tel })
      }
    }

    // set return
    if (dataSet.address === undefined &&
       dataSet.tax_id === undefined &&
       dataSet.contacts.insert.length === 0 &&
       dataSet.contacts.update.length === 0 &&
       dataSet.contacts.delete.length === 0) {
      return null
    } else {
      return dataSet
    }
  },
}

// mutations
const mutations = {
  setVendor (state, data) {
    state.vendor = data
  },
  setVendors (state, data) {
    state.vendors = data
  },
  setCustomer (state, data) {
    state.customer = data
  },
  setCustomers (state, data) {
    state.customers = data
  },
  setPartners (state, data) {
    state.partners = data
  },
}

// actions
const actions = {
  async getVendors ({ commit }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getVendors') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getVendors')

      let response = await VendorService.getAll()

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getVendors')

      result = response.data

      if (result.success) {
        commit('setVendors', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async getVendor ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getVendor') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getVendor')

      let response = await VendorService.getSingle(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getVendor')

      result = response.data

      if (result.success && result.data.length > 0) {
        commit('setVendor', result.data[0])
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async getCustomers ({ commit }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getCustomers') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getCustomers')

      let response = await CustomerService.getAll()

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getCustomers')

      result = response.data

      if (result.success) {
        commit('setCustomers', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async getCustomer ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getCustomer') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getCustomer')

      let response = await CustomerService.getSingle(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getCustomer')

      result = response.data

      if (result.success && result.data.length > 0) {
        commit('setCustomer', result.data[0])
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async getPartners ({ commit }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getPartners') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getPartners')

      let response = await PartnerService.getAll()

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getPartners')

      result = response.data

      if (result.success) {
        commit('setPartners', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async insertVendor ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await VendorService.insert(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {
        commit('setVendor', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async insertCustomer ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await CustomerService.insert(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {
        commit('setCustomer', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateVendor ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await VendorService.update(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateCustomer ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await CustomerService.update(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async deleteVendor ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await VendorService.delete(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async deleteCustomer ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await CustomerService.delete(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  clearVendor ({ commit }) {
    commit('setVendor', null)
  },
  clearVendors ({ commit }) {
    commit('setVendors', [])
  },
  clearCustomer ({ commit }) {
    commit('setCustomer', null)
  },
  clearCustomers ({ commit }) {
    commit('setCustomers', [])
  },
  clearPartners ({ commit }) {
    commit('setPartners', [])
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/Partner.js